// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Lobby Component CSS Module
 * Optimized for instant view switching performance
 */
.Ogk6BIv9mWkhhfcs1FIC {
  width: 100%;
  flex: 1;
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  /* Scroll anchoring: adjust position when content above viewport changes height */
  overflow-anchor: auto;
  -webkit-overflow-scrolling: touch;
  /* Prevent scroll chaining conflicts with horizontal sections */
  overscroll-behavior: contain;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}
.Ogk6BIv9mWkhhfcs1FIC::after {
  content: '';
  display: block;
  height: var(--lobby-bars-height);
}
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"] {
  contain: layout style paint;
}
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="PRIZE_POP"],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="TOURNAMENTS"],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="REBATE"] {
  display: flex;
  background: var(--app-background, #141414);
  scrollbar-gutter: stable;
}
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="PRIZE_POP"][data-campaign-only='true'],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="TOURNAMENTS"][data-campaign-only='true'],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="REBATE"][data-campaign-only='true'] {
  max-height: 100%;
}
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="PRIZE_POP"][data-open-type='ingame'],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="TOURNAMENTS"][data-open-type='ingame'],
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-section="REBATE"][data-open-type='ingame'] {
  height: 100%;
  max-height: 100%;
  scrollbar-gutter: auto;
}
.Ogk6BIv9mWkhhfcs1FIC[data-open-type='ingame'] {
  /* Sized against the viewport, not the parent: ViewControl offsets this subtree down
     by the popup title bar, and a parent-relative height ends up below the visible
     area, taking the trailing bars clearance off-screen with it.
     The vh pair is the fallback — browsers without dvh drop the second declaration. */
  height: calc(100vh - var(--lobby-ingame-popup-title-bar-height));
  height: calc(100dvh - var(--lobby-ingame-popup-title-bar-height));
  max-height: calc(100vh - var(--lobby-ingame-popup-title-bar-height));
  max-height: calc(100dvh - var(--lobby-ingame-popup-title-bar-height));
}
.Ogk6BIv9mWkhhfcs1FIC[data-open-type='ingame'][data-view="single"] {
  width: 100%;
}
/* Tournament navigation mode - use smaller tournament nav height and exclude status bar */
.Ogk6BIv9mWkhhfcs1FIC[data-view="single"][data-tournament-navigation="true"] {
  max-height: calc(100% - var(--tournament-navigator-height));
}
.ETT52C3R3jUq7lHanjcs {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #b0b0b0;
  min-height: 50vh;
  min-height: 50dvh;
  padding: 20px 16px;
  font-size: 14px;
}
/* Do not reintroduce \`-webkit-fill-available\` heights here under
   @supports (-webkit-touch-callout: none): being Safari-only it is invisible to Chrome,
   and it stretched this scroller past the visible area, taking the bars clearance
   off-screen. \`100dvh\` handles the address bar instead. */
@media (min-width: 430px) {
  .ETT52C3R3jUq7lHanjcs {
    padding: 24px 20px;
    font-size: 15px;
  }
}
@media (min-width: 768px) {
  .ETT52C3R3jUq7lHanjcs {
    padding: 32px 24px;
    font-size: 16px;
  }
}
@media (min-width: 1024px) {
  .ETT52C3R3jUq7lHanjcs {
    padding: 40px 32px;
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Lobby/Lobby.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,WAAW;EACX,OAAO;EACP,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,iFAAiF;EACjF,qBAAqB;EACrB,iCAAiC;EACjC,+DAA+D;EAC/D,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE;;;sFAGoF;EACpF,gEAAgE;EAChE,iEAAiE;EACjE,oEAAoE;EACpE,qEAAqE;AACvE;AACA;EACE,WAAW;AACb;AACA,0FAA0F;AAC1F;EACE,2DAA2D;AAC7D;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;;;0DAG0D;AAC1D;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/**\n * Lobby Component CSS Module\n * Optimized for instant view switching performance\n */\n.lobbyContainer {\n  width: 100%;\n  flex: 1;\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Scroll anchoring: adjust position when content above viewport changes height */\n  overflow-anchor: auto;\n  -webkit-overflow-scrolling: touch;\n  /* Prevent scroll chaining conflicts with horizontal sections */\n  overscroll-behavior: contain;\n  display: block;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 0;\n}\n.lobbyContainer::after {\n  content: '';\n  display: block;\n  height: var(--lobby-bars-height);\n}\n.lobbyContainer[data-view=\"single\"] {\n  contain: layout style paint;\n}\n.lobbyContainer[data-view=\"single\"][data-section=\"PRIZE_POP\"],\n.lobbyContainer[data-view=\"single\"][data-section=\"TOURNAMENTS\"],\n.lobbyContainer[data-view=\"single\"][data-section=\"REBATE\"] {\n  display: flex;\n  background: var(--app-background, #141414);\n  scrollbar-gutter: stable;\n}\n.lobbyContainer[data-view=\"single\"][data-section=\"PRIZE_POP\"][data-campaign-only='true'],\n.lobbyContainer[data-view=\"single\"][data-section=\"TOURNAMENTS\"][data-campaign-only='true'],\n.lobbyContainer[data-view=\"single\"][data-section=\"REBATE\"][data-campaign-only='true'] {\n  max-height: 100%;\n}\n.lobbyContainer[data-view=\"single\"][data-section=\"PRIZE_POP\"][data-open-type='ingame'],\n.lobbyContainer[data-view=\"single\"][data-section=\"TOURNAMENTS\"][data-open-type='ingame'],\n.lobbyContainer[data-view=\"single\"][data-section=\"REBATE\"][data-open-type='ingame'] {\n  height: 100%;\n  max-height: 100%;\n  scrollbar-gutter: auto;\n}\n.lobbyContainer[data-open-type='ingame'] {\n  /* Sized against the viewport, not the parent: ViewControl offsets this subtree down\n     by the popup title bar, and a parent-relative height ends up below the visible\n     area, taking the trailing bars clearance off-screen with it.\n     The vh pair is the fallback — browsers without dvh drop the second declaration. */\n  height: calc(100vh - var(--lobby-ingame-popup-title-bar-height));\n  height: calc(100dvh - var(--lobby-ingame-popup-title-bar-height));\n  max-height: calc(100vh - var(--lobby-ingame-popup-title-bar-height));\n  max-height: calc(100dvh - var(--lobby-ingame-popup-title-bar-height));\n}\n.lobbyContainer[data-open-type='ingame'][data-view=\"single\"] {\n  width: 100%;\n}\n/* Tournament navigation mode - use smaller tournament nav height and exclude status bar */\n.lobbyContainer[data-view=\"single\"][data-tournament-navigation=\"true\"] {\n  max-height: calc(100% - var(--tournament-navigator-height));\n}\n.emptyLobby {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: #b0b0b0;\n  min-height: 50vh;\n  min-height: 50dvh;\n  padding: 20px 16px;\n  font-size: 14px;\n}\n/* Do not reintroduce `-webkit-fill-available` heights here under\n   @supports (-webkit-touch-callout: none): being Safari-only it is invisible to Chrome,\n   and it stretched this scroller past the visible area, taking the bars clearance\n   off-screen. `100dvh` handles the address bar instead. */\n@media (min-width: 430px) {\n  .emptyLobby {\n    padding: 24px 20px;\n    font-size: 15px;\n  }\n}\n@media (min-width: 768px) {\n  .emptyLobby {\n    padding: 32px 24px;\n    font-size: 16px;\n  }\n}\n@media (min-width: 1024px) {\n  .emptyLobby {\n    padding: 40px 32px;\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lobbyContainer": `Ogk6BIv9mWkhhfcs1FIC`,
	"emptyLobby": `ETT52C3R3jUq7lHanjcs`
};
export default ___CSS_LOADER_EXPORT___;
